function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, visibility) {
    var h = require("panel").h;
    const placement = $attr(`placement`);;
    return {
      value: (h("div", {
        "hook": {
          /*
           * The visibility of the tooltip can change, will change the size of the tooltip. Hence, the tooltip's
           * position should be recomputed when this happens.
           */
          insert: $helpers.handleUpdatedTooltip,
          postpatch: $helpers.handleUpdatedTooltip,
        },
        "on": {
          click: $helpers.handleClick
        },
        "class": Object.assign({}, {
          [`mp-sh-tooltip-placement-${placement}`]: true,
          [`mp-sh-tooltip-visibility-${visibility}`]: true,
        }, {
          'mp-sh-tooltip-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-smart-hub-alert-v2", {
          "attrs": {
            'project-id': $attr(`project-id`),
            'utc-offset': $attr(`utc-offset`),
            'display-context': `IN_REPORT`,
            'explains-value': $attr(`explains-value`),
            'alert': JSON.stringify($attr(`alert`)),
            'alert-color': $attr(`alert-color`),
            'visible': $helpers.isVisible(),
            'workspace-id': $attr(`workspace-id`),
          },
          "on": {
            changedAlert: $helpers.handleChangedAlert,
          },
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "visibility" in locals ? locals.visibility : typeof visibility !== "undefined" ? visibility : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;